export default __webpack_public_path__ + "locales/ja-JP/Payments.json?hash=5c0e60ada3f26f39bea4a27a3f540e18";